























import type { PropType } from '@vue/composition-api';
import { toRefs, defineComponent } from '@vue/composition-api';
import type { Section } from '@getaccept/editor-lib';
import { storeToRefs } from 'pinia';
import NameInput from '@getaccept/dsr-shared/src/components/NameInput.vue';
import { useTrackingStore } from '../tracking/store/tracking.store';

export default defineComponent({
  name: 'SectionList',
  components: {
    NameInput,
  },
  props: {
    contentId: {
      type: String as PropType<string>,
      required: true,
    },
    sections: {
      type: Array as PropType<Section[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { contentId } = toRefs(props);
    const trackingStore = useTrackingStore();
    const { visibleSections } = storeToRefs(trackingStore);

    const isInView = (id: string) => visibleSections.value.includes(id);
    const navigateToSection = (sectionId: string) => {
      emit('navigate-to-section', { contentId: contentId.value, sectionId });
    };

    return { navigateToSection, isInView };
  },
});
